<template>
  <div class="container-xxl py-5">
    <div class="container">
      <div
        class="text-center mx-auto wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <p class="fs-5 fw-bold text-primary">Unser Team</p>
        <h1 class="display-5 mb-5">Engagierte & erfahrene Teammitglieder</h1>
      </div>
      <div class="row g-4">
        <div class="col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
          <div class="team-item rounded">
            <img
              class="img-fluid"
              src="img/gazi-550x650.png"
              :alt="globalConfig.altPictureText"
            />
            <div class="team-text">
              <h4 class="mb-0">Gazmend Halimi</h4>
              <p class="text-primary">Landscape Designer</p>
              <div class="team-social d-flex">
                <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <!-- <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-twitter"></i
                ></a> -->
                <a
                  class="btn btn-square rounded-circle me-2"
                  href="https://www.instagram.com/gartenbau.gazihalimi?igsh=MTBiY212bXh5enNoYQ%3D%3D"
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="0.3s">
          <div class="team-item rounded">
            <img
              class="img-fluid"
              src="img/lini-550x650.jpg"
              :alt="globalConfig.altPictureText"
            />
            <div class="team-text">
              <h4 class="mb-0">Brooklyn Halimi</h4>
              <p class="text-primary">Garden Designer</p>
              <div class="team-social d-flex">
                <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <!-- <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-twitter"></i
                ></a> -->
                <a
                  class="btn btn-square rounded-circle me-2"
                  href="https://www.instagram.com/gartenbau.gazihalimi?igsh=MTBiY212bXh5enNoYQ%3D%3D"
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 wow fadeInUp" data-wow-delay="0.3s">
          <div class="team-item rounded">
            <img
              class="img-fluid"
              src="img/vjosa-550x650.jpg"
              :alt="globalConfig.altPictureText"
            />
            <div class="team-text">
              <h4 class="mb-0">Vjosa Halimi</h4>
              <p class="text-primary">Rechnungswesen</p>
              <div class="team-social d-flex">
                <!-- <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a> -->
                <!-- <a class="btn btn-square rounded-circle me-2" href=""
                  ><i class="fab fa-twitter"></i
                ></a> -->
                <!-- <a
                  class="btn btn-square rounded-circle me-2"
                  href="https://www.instagram.com/iamvjosa.ha?igsh=dGVkbXFmOG5rY280"
                  ><i class="fab fa-instagram"></i
                ></a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import config from '../../store/global.js';
const globalConfig = config.global().globalConfig;
</script>
